module.exports = __webpack_public_path__ + "static/media/bg-line.e844690c.svg";